
<div class="main">
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <div class="warning">
      本システムはメールアドレスをログインIDとしており、原則登録したメールアドレスを変更することはできません。<br/>１つの団体アカウントにつき複数のユーザーを登録することが可能です。「ユーザー追加」から追加するご担当者様を登録してください。<br/>
      なお、メールアドレスの変更を希望する場合は、「ユーザー追加」から未登録のメールアドレスを登録し、不要となったメールアドレスを「削除」することで変更が可能です。
    </div>
    <div class="title">
      <h1 class="text-title">ユーザー管理</h1>
    </div>

    <div class="result-area">
      <a id="jump-top"></a>
      <button
        pButton
        type="button"
        label="ユーザー追加"
        class="button1"
        (click)="moveInsertB221()"
        *ngIf="this.class_id !== '3'"
      ></button>
      <p-table
        [value]="resultTaskDataList"
        [rows]="50"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first}～{last}件表示({totalRecords}件中)"
        [rowsPerPageOptions]="[10, 50, 100, 500, 1000]"
        emptyMessage="データが存在しません"
        selectionMode="single"
        styleClass="information-Form list-area"
        (onPage)="jumpTop()"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="user_id" scope="col">アカウントNO</th>
            <th class="full_name" scope="col">氏名</th>
            <th class="email" scope="col">メールアドレス</th>
            <th class="actions-large" scope="col"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-resultTaskData>
          <tr class="list">
            <td>
              {{ resultTaskData.user_id }}
            </td>
            <td>
              {{ resultTaskData.full_name }}
            </td>
            <td>
              {{ resultTaskData.email }}
            </td>
            <td class="desktop">
              <button
                pButton
                type="button"
                label="編集"
                class="button1"
                *ngIf="resultTaskData.isOwner == 1"
                (click)="moveEditB221(resultTaskData.user_id)"
              ></button>

              <button
                pButton
                type="button"
                label="削除"
                class="btn-delete"
                *ngIf="isDelete"
                (click)="deleteUser(resultTaskData.user_id)"
              ></button>
            </td>
            <td class="mobile actions-large">
              <button
                pButton
                *ngIf="resultTaskData.isOwner == 1"
                (click)="moveEditB221(resultTaskData?.user_id)"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                pTooltip="編集"
                tooltipPosition="bottom"
              ></button>

              <button
                pButton
                (click)="deleteUser(resultTaskData?.user_id)"
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger"
                pTooltip="削除"
                tooltipPosition="bottom"
                *ngIf="isDelete"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

